<section class="main-section">
    <section class="border-0 h-100 w-100 bg-transparent">
        <div class="text-center">

            <div class="card h-100 shadow">
                <div class="card-body">

                    <h2 class="mb-3 d-none d-lg-block">{{ 'Priebežné hodnotenie' | translate }}</h2>

                    <app-zapisny-list-selector></app-zapisny-list-selector>

                    <div class="d-flex flex-row justify-content-end mt-sm-3 me-sm-3">
                        <app-semester-selector></app-semester-selector>
                    </div>

                    <div *ngIf="!hodnotenia || hodnotenia.length == 0">
                        <h2 class="m-5 p-5 text-center">
                            <span i18n>Nemáte zaevidované žiadne priebežné hodnotenie.</span>
                        </h2>
                    </div>

                    <div *ngFor="let i of hodnotenia">
                        <app-priebezne-hodnotenie-item [ph]="i"></app-priebezne-hodnotenie-item>
                    </div>

                </div>
            </div>
        </div>
    </section>
</section>
